import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/lx/migration-guide',
    name: 'lxMigrationGuide',
    component: () =>
      import(/* webpackChunkName: "lxMigrationGuide" */ '@/views/lx/MigrationGuide.vue'),
    meta: {
      cname: '服务迁移指导'
    }
  },
  {
    path: '/lx/paLimit',
    name: 'lxPaLimit',
    component: () => import(/* webpackChunkName: "nfcIntro" */ '@/views/lx/privacy/Privacy.vue'),
    meta: {
      cname: 'nfc介绍'
    }
  },
  {
    path: '/lx/commonShare',
    name: 'lxCommonShare',
    component: () =>
      import(/* webpackChunkName: "lxCommonShare" */ '@/views/lx/CommonShare/CommonShare.vue'),
    meta: {
      cname: '第三方信息共享清单'
    }
  },
  {
    path: '/lx/personCollect',
    name: 'lxPersonCollect',
    component: () =>
      import(/* webpackChunkName: "lxPersonCollect" */ '@/views/lx/PersonCollect.vue'),
    meta: {
      cname: '个人信息收集清单'
    }
  },
  {
    path: '/lx/commonProblems/detail',
    name: 'lxCommonProblemsDetail',
    component: () =>
      import(
        /* webpackChunkName: "lxCommonProblemsDetail" */ '@/views/lx/help-center/QuestionDetail.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    path: '/lx/paRegist',
    name: 'lxPaRegist',
    component: () => import(/* webpackChunkName: "lxPaRegist" */ '@/views/lx/Agreements.vue'),
    meta: {
      cname: '灵犀用户协议'
    }
  },
  // 常见问题--巴盾数钥
  {
    path: '/commonProblems_paton',
    name: 'commonProblemsPaton',
    component: () =>
      import(/* webpackChunkName: "CustomerServicePT" */ '@/views/lx/help-center/HelpCenter.vue'),
    meta: {
      cname: '帮助中心'
    }
  },
  {
    // @deprecated 用户服务协议-巴盾数钥
    path: '/paRegist_paton',
    name: 'paRegist_paton',
    component: () =>
      import(/* webpackChunkName: "AgreementsPT" */ '@/views/pt/agreements/AgreementsPT.vue')
  },
  // 常见问题--巴盾lite
  {
    path: '/commonProblems_paton_lite',
    name: 'commonProblemsPatonLite',
    component: () =>
      import(/* webpackChunkName: "CustomerServicePTLite" */ '@/views/lx/help-center/LiteView.vue'),
    meta: {
      cname: '帮助中心'
    }
  }
];
export default routes;
